var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "17px",
    viewBox: "0 0 9 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path_1076-path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.86973995,2.44319754 L1.29033911,5.09033386 C1.12820808,5.23990188 0.880385086,5.23313675 0.726231162,5.07493472 C0.572077237,4.91673269 0.56548522,4.66240183 0.711226059,4.49601321 L3.99808393,1.12284193 C4.15813378,0.95905269 4.41714712,0.95905269 4.57719698,1.12284193 L7.86405485,4.49601321 C7.97688338,4.60009901 8.02449655,4.75960975 7.98783447,4.91069211 C7.95117239,5.06177448 7.83622625,5.17973913 7.68900981,5.21736396 C7.54179337,5.25498879 7.38636423,5.20612529 7.28494179,5.09033386 L4.68988925,2.44319754 L4.68988925,15.7318861 C4.68988923,15.9643114 4.50629256,16.1527293 4.2798146,16.1527293 C4.05333664,16.1527293 3.86973997,15.9643114 3.86973995,15.7318861 L3.86973995,2.44319754 Z",
    id: "Path_1076-path",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.24d908496f16d09f620f1fec49f1a4dd.svg";
export { ForwardRef as ReactComponent };